import { ICenter } from '@nkr/models/center';

export interface ISelectedCenter extends ICenter {
    selected: boolean
}